<template>
	<ul class="expanding-list list-unstyled">
		<li v-for="item in displayItems" :key="item">
			<span v-if="item === 'more ...'"><button @click="clickMore" class="linkButton passwordLink">{{item}}</button></span>
			<span v-else>{{item}}</span>
		</li>
	</ul>
</template>

<script>

export default {
	name: 'ExpandingList',
	props: ['items','count'],
	data() {
		return {
			expanded: false
		}
	},
	computed: {
		displayItems() {
			if (!this.items) return [];
			const count = this.count || 3;

			if (this.expanded || this.items.length <= count) return this.items;

			const items = this.items.slice(0, count);
			items.push('more ...');
			return items; 
		}
	},
	methods: {
		clickMore() {
			this.expanded = true;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/ExpandingList.vue